import React, { useState, useEffect } from "react";
import { Icon } from "@iconify/react";
import Button from "../../Components/Button";
import RequiredCard from "../../Components/RequiredCard";
import { getListRecommendCentre } from "../Services/EnquiryService";
import styles from "../styles.module.scss";
const numberText = {
    1: "One",
    2: "Two",
    3: "Three",
};

export type CentreType = {
    name?: string;
    latitude?: number;
    longitude?: number;
    distance?: null;
    addressLine1?: string;
    suburb?: string;
    state?: string;
    postcode?: string;
    telephone?: string;
    trackingPhoneNumber?: string;
    isBasicListing?: boolean;
    ratingAverageC4k?: number;
    ratingAverageGoogle?: number;
    ratingAverageCombined?: number;
    hasVacancies?: boolean;
    hasVacanciesMatchingFilter?: boolean;
    hasOvernightCare?: boolean;
    centreUserId?: number;
    centreUserIdHash?: string;
    vacancyAgeGroupsByCentreTypeName?: VacancyAgeGroupsByCentreTypeName;
    ageGroupCentreTypeNames?: CentreTypeName[];
    feeGroups?: FeeGroup[];
    coordinatorCentreUserId?: null;
    coordinatorName?: null;
    coordinatorServiceApprovalNumber?: string;
    hasLogo?: boolean;
    logoUrl?: string;
    hasWaitlist?: boolean;
    hasWaitlistPeriod?: boolean;
    waitlistPeriod?: WaitlistPeriod;
    externalWaitlistUrl?: string;
    canReceiveEmail?: boolean;
    canReceiveRatingEmail?: boolean;
    accountStatus?: number;
    productSubscription?: number;
    toddlerUserId?: number;
    toddleSlug?: string;
    hasAnyCCCVacs?: boolean;
    vacanciesAvailableFromDate?: null;
    profileUrl?: string;
    contactName?: string;
    contactTime?: string;
    websiteUrl?: string;
    reviewCountC4k?: number;
    reviewCountGoogle?: number;
    reviewCountCombined?: number;
    hasExternalWaitlistUrl?: boolean;
    waitlistUrl?: string;
    userLastLogin?: Date;
    liveChatUrl?: string;
    externalCentreId?: null;
    useEmbeddedRequestATourForm?: boolean;
    useEmbeddedWaitListForm?: boolean;
    embeddedRequestATourUrl?: null;
    embeddedWaitListUrl?: null;
    instagramAccount?: string;
    centreQualityAreaRatingsModel?: CentreQualityAreaRatingsModel;
    hasLiveTourBooking?: boolean;
    googlePlaceId?: string;
    highlights?: string;
    hasFdcProfileImage?: null;
    doesWaitlistRequiresParentLogin?: boolean;
    centreTypeStr?: string;
    facebookRelativeUrl?: string;
    instagramUrl?: string;
    videoContentUrl?: null;
    isVideoContentEmbeddable?: boolean;
    centreGroupId?: null;
    centreGroupName?: string;
    hasSpecialOffer?: boolean;
    specialOfferTypeName?: null;
    specialOfferTitle?: null;
    serviceApprovalNumber?: string;
    numnberOfApprovedPlaces?: string;
    isFeatured?: boolean;
    featuredPosition?: number;
    occasionalCareBookingUrl?: null;
    isFamilyDayCareEducator?: boolean;
    nqRating?: string;
    nqRatingOverall?: string;
    coordinatorRating?: string;
    nqRatingLabel?: string;
    isFavourite?: boolean;
    favouriteNotes?: null;
    displayOrder?: number;
    parentRecentActivities?: null;
    listingType?: string;
    dailyAverageFee?: number;
    gallaryImageIds?: number[];
    galleryImageUrls?: string[];
    hasApprovedKindieProgram?: boolean;
    demoted?: boolean;
    tagsList?: null;
    tags?: any[];
    reviews?: null;
};

export type CentresSelected = {
    index: number;
    name: string;
    centreUserId: number;
    centreUserIdHash?: string;
    centreGroupId?: number
    listingType?: string;
    suburb?: string;
    postcode?: string;
    state?: string;
};

export enum CentreTypeName {
    LongDayCare = "Long Day Care",
    PreSchool = "Pre-school",
}

export type CentreQualityAreaRatingsModel = {
    qualtiyAreaRatingLabels?: string[];
    lastUpdated?: Date;
};

export type FeeGroup = {
    centreTypeId?: number;
    fees?: Fee[];
    centreTypeName?: CentreTypeName;
};

export type Fee = {
    feeId?: number;
    centreUserId?: number;
    centreTypeName?: CentreTypeName;
    feeTypeDisplay?: string;
    sessionHours?: number;
    sessionMinutes?: null;
    fromWeeks?: number;
    fromMonths?: null;
    fromYears?: null;
    fromDaysTotal?: number;
    toWeeks?: null;
    toMonths?: null;
    toYears?: number;
    toDaysTotal?: number;
    minPrice?: null;
    maxPrice?: number;
    centreTypeId?: number;
    includedBenefits?: any[];
    notes?: null;
    isApprovedForChildCareBenefitAndRebate?: boolean;
};

export type VacancyAgeGroupsByCentreTypeName = {
    "Long Day Care"?: LongDayCare[];
    "Pre-school"?: LongDayCare[];
};

export type LongDayCare = {
    description?: string;
    hasVacancyForDayOfWeek?: boolean[];
    fromDays?: number;
    toDays?: number;
    centreType?: number;
    centreTypeName?: CentreTypeName;
    ageGroupLabelName?: null;
};

export type WaitlistPeriod = {
    weeks?: null;
    months?: null;
    years?: null;
};

type Props = {
    setDataEnquiry: React.Dispatch<
        React.SetStateAction<{
            startEnquiry: any[];
            parentDetail: {
                parentFirstName: string;
                parentLastName: string;
                email: string;
                contactNumber: string;
                suburb: {
                    label: string;
                    postcode: string;
                };
            };
            childDetail: any[];
            maximiseOptions: CentresSelected[];
            centreUserIdHash: string;
            pickerTimePersonTour: {
                isBackDateTimeExists: boolean;
                startDate: string;
                endDate: string;
                tourDate: string;
                tourTime: string;
                availabilityDetailsResponse: any[];
                availabilityDetails: any[];
                isDateTimeApiLoading: boolean;
            };
            chooseTime: {};
            createAccount: {};
        }>
    >;
    goToNextStep: () => void;
    postcode: string;
    maximiseOptions: CentresSelected[];
    sendEventGa4: (action: string, formStep: string) => void;
    initialCareCentre: any;
    enquiryCentreDetailsList: any
};
declare var c4kCore: any;
function MaximiseOptions({
    goToNextStep,
    setDataEnquiry,
    postcode,
    maximiseOptions,
    sendEventGa4,
    initialCareCentre,
    enquiryCentreDetailsList
}: Props) {
    const [selectedCentres, setSelectedCentres] = useState<CentresSelected[]>(
        maximiseOptions || []
    );
    const [isLoading, setIsLoading] = useState(true);

    const [centres, setCentres] = useState([]);
    useEffect(() => {
        getListRecommendCentre(postcode)
            .then((res: any) => {
                if (res?.data?.length === 0) {
                    handleNext();
                    return;
                }
                setCentres(res.data);
            })
            .catch((error) => {
                console.error("error", error);
            })
            .finally(() => {
                setIsLoading(false);
            });
    }, [postcode]);

    const handleFindCentre = (centre: number) => {
        return selectedCentres.some((item) => item.centreUserId === centre);
    };

    const handleSelectCentre = (centre: CentresSelected, index: number) => {
        setSelectedCentres((prev) => {
            if (prev.some((item) => item.centreUserId === centre.centreUserId)) {
                return prev.filter((item) => item.centreUserId !== centre.centreUserId);
            }
            sendEventGa4("basic-upsell", `centre-${index + 1}`);
            c4kCore.sendGa4EventForNewEnquiry({
                Action: "select-centre",
                Source: "CLP",
                CentreId:
                    centre.centreUserIdHash || null,
                CentreGroupId:
                    centre.centreGroupId || null,
                ListingType: centre.listingType || null,
                Suburb: centre.suburb,
                Postcode: centre.postcode,
                State: centre.state,
                FormStep: "maximise",
            });
            return [...prev, centre];
        });
    };

    const handleNext = () => {
        sendEventGa4(
            "basic-upsell",
            selectedCentres.length > 0 ? "upsell-cta" : "none-centre-selected"
        );
        setDataEnquiry((prev) => ({
            ...prev,
            maximiseOptions: selectedCentres,
        }));
        goToNextStep();
    };

    return (
        <div className="text-[#3A3A3A]">
            <h2 className="text-[#3A3A3A] leading-8 mb-4 md:mb-6 text-2xl md:text-[20px] font-semibold">
                Maximise Your Options!
            </h2>
            <p className="text-base text-black">
                Based on your enquiry, we’ve selected other great centres you might love
                - Just select a centre and we’ll add to your enquiry...
            </p>

            <div className="flex-1 overflow-y-auto">
                <div className="mx-auto mt-8 max-w-[756px] space-y-6 md:space-y-8 md:mt-12">
                    {isLoading
                        ? [0, 1, 2].map((i) => (
                            <div
                                key={i}
                                className={`${styles.skeleton} h-[119px] md:h-[198px] rounded-lg`}
                            />
                        ))
                        : centres.length
                            ? centres.map((i: CentreType, index) => (
                                <div
                                    onClick={() =>
                                        handleSelectCentre(
                                            {
                                                centreUserId: i.centreUserId,
                                                name: i.name,
                                                centreUserIdHash: i.centreUserIdHash,
                                                index: index,
                                            },
                                            index
                                        )
                                    }
                                    key={i.centreUserId}
                                    className="flex rounded-lg border border-[#D9D8DF] bg-white"
                                >
                                    <div className="flex-shrink-0 relative">
                                        <img
                                            src={
                                                i.galleryImageUrls?.length > 0
                                                    ? i.galleryImageUrls[0]
                                                    : "/img/default-placeholder.png"
                                            }
                                            className=" h-full w-[119px] rounded-[8px_0px_0px_8px] object-cover md:h-[198px] md:w-[239px]"
                                            alt="Placeholder Img"
                                        />
                                        <div className="bg-white/60 absolute left-[5px] top-1 flex items-center gap-x-1 rounded px-2 py-1">
                                            <span className="leading-5 text-sm font-bold text-[#3A3A3A]">
                                                {i.ratingAverageCombined
                                                    ? i.ratingAverageCombined.toFixed(1)
                                                    : "0.0"}
                                            </span>
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="15"
                                                height="14"
                                                viewBox="0 0 15 14"
                                                fill="none"
                                            >
                                                <path
                                                    d="M2.87798 13.3876C3.15491 13.5836 3.50613 13.5162 3.92489 13.2406L7.49792 10.8578L11.0777 13.2406C11.4965 13.5162 11.8409 13.5836 12.1246 13.3876C12.4015 13.1977 12.4623 12.8853 12.2935 12.4382L10.8818 8.62824L14.4886 6.27613C14.9074 6.00662 15.0762 5.72486 14.9682 5.4186C14.8601 5.12458 14.5426 4.97758 14.0226 4.9837L9.5985 5.0082L8.2544 1.17991C8.09229 0.726635 7.84914 0.5 7.49792 0.5C7.15345 0.5 6.91029 0.726635 6.74819 1.17991L5.40409 5.0082L0.980022 4.9837C0.459941 4.97758 0.142489 5.12458 0.0344207 5.4186C-0.0804023 5.72486 0.0952093 6.00662 0.513976 6.27613L4.12077 8.62824L2.70912 12.4382C2.54026 12.8853 2.60105 13.1977 2.87798 13.3876Z"
                                                    fill="#FFAE20"
                                                />
                                            </svg>
                                        </div>
                                    </div>
                                    <div className="flex flex-col justify-between gap-y-2 p-2 md:px-6 md:py-4 flex-1">
                                        <div>
                                            <p className="leading-5 text-sm md:text-[16px] font-semibold">
                                                {i.name}{" "}
                                                {i.listingType !== "basic" && (
                                                    <svg
                                                        className="inline relative bottom-px"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width="17"
                                                        height="16"
                                                        viewBox="0 0 17 16"
                                                        fill="none"
                                                    >
                                                        <path
                                                            d="M14.9601 5.82811C14.7096 5.05126 15.5188 3.72342 15.0513 3.07687C14.5793 2.42379 13.0712 2.79035 12.4224 2.31518C11.7801 1.84459 11.6634 0.285248 10.8917 0.0329393C10.1471 -0.210378 9.14534 0.974117 8.32 0.974117C7.49483 0.974117 6.49293 -0.210378 5.74833 0.0329393C4.97659 0.285248 4.85993 1.84459 4.21745 2.31518C3.56884 2.79053 2.06108 2.42362 1.58886 3.07669C1.12136 3.72325 1.93059 5.05144 1.67994 5.82829C1.43805 6.57781 0 7.16953 0 8.00016C0 8.83096 1.43805 9.4225 1.67976 10.172C1.93042 10.9489 1.12119 12.2769 1.58851 12.9234C2.06073 13.5765 3.56849 13.2096 4.21728 13.685C4.85958 14.1554 4.97624 15.7149 5.74816 15.967C6.49275 16.2105 7.49448 15.0258 8.31983 15.0258C9.14517 15.0258 10.1469 16.2105 10.8915 15.967C11.6632 15.7149 11.7799 14.1557 12.4222 13.685C13.071 13.2098 14.5789 13.5767 15.0511 12.9234C15.5188 12.2769 14.7096 10.9489 14.9599 10.172C15.202 9.4225 16.64 8.83096 16.64 8.00016C16.64 7.16953 15.202 6.57781 14.9601 5.82811ZM11.6282 6.28759L7.9632 10.3088C7.95987 10.3125 7.95585 10.315 7.95234 10.3185C7.94394 10.3274 7.93448 10.3344 7.92554 10.3423C7.90733 10.3582 7.88894 10.3725 7.86897 10.3848C7.85881 10.391 7.84865 10.3967 7.83814 10.4023C7.81625 10.4134 7.79365 10.4222 7.77035 10.4296C7.76072 10.4326 7.75161 10.4361 7.7418 10.4386C7.70852 10.4465 7.67472 10.4517 7.64056 10.4517C7.64056 10.4517 7.64039 10.4517 7.64021 10.4517C7.64004 10.4517 7.63969 10.4515 7.63951 10.4515C7.60606 10.4515 7.57278 10.4462 7.54002 10.4384C7.53109 10.4363 7.52251 10.4337 7.51375 10.431C7.4845 10.422 7.4563 10.4104 7.42897 10.3952C7.42547 10.3933 7.42179 10.3928 7.41846 10.3908L5.11216 9.02279C4.90372 8.89919 4.83436 8.6289 4.95714 8.41908C5.07993 8.20944 5.3481 8.13945 5.55671 8.26304L7.55754 9.44983L10.9829 5.69182C11.1463 5.51233 11.4233 5.50052 11.6016 5.66502C11.7797 5.82935 11.7916 6.10828 11.6282 6.28759Z"
                                                            fill="#5A60EC"
                                                        />
                                                    </svg>
                                                )}
                                            </p>
                                            <p className="leading-4 mt-1 text-xs md:text-[16px] font-normal">
                                                {i.addressLine1}
                                            </p>
                                        </div>
                                        <div className="flex items-center justify-between">
                                            <div
                                                className={`flex flex-col ${i.dailyAverageFee ? "" : "invisible"
                                                    }`}
                                            >
                                                <span className="leading-6 text-base md:text-[24px] font-semibold">
                                                    ${i.dailyAverageFee}
                                                </span>
                                                <span className="leading-5 text-sm md:text-[16px] italic">
                                                    avg. per day
                                                </span>
                                            </div>
                                            <button className="mr-2">
                                                {handleFindCentre(i.centreUserId) ? (
                                                    <Icon
                                                        icon="fa6-solid:circle-check"
                                                        width="30"
                                                        height="30"
                                                        className="text-[#5A60EC]"
                                                    />
                                                ) : (
                                                    <Icon
                                                        icon="fluent:add-circle-32-regular"
                                                        width="32"
                                                        height="32"
                                                        className="text-[#5A60EC]"
                                                    />
                                                )}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            ))
                            : "Not found centres"}
                </div>
                {!!selectedCentres.length && (
                    <RequiredCard customClass="!border-l-[#5A60EC] pl-2 md:max-w-[756px] md:mx-auto mt-8">
                        <p className="leading-6 text-base font-semibold text-[#5A60EC]">
                            {numberText[selectedCentres.length]}{" "}
                            {selectedCentres.length > 1 ? "centres" : "centre"} added to your
                            enquiry
                        </p>
                    </RequiredCard>
                )}
                <div className="flex lg:justify-center">
                    <Button
                        type="button"
                        onClick={handleNext}
                        customClass="w-full lg:w-fit md:block md:mt-8 mt-10"
                    >
                        Next
                    </Button>
                </div>
            </div>
        </div>
    );
}

export default MaximiseOptions;
